module.exports = __webpack_public_path__ + "img/62_8.87f431bc.png";